import { UrlApi } from '../../../../services/apirest';

const API_URL = `${UrlApi}/envasado_posnets_choferes`;

// Error con el status HTTP y el body de la respuesta (p.ej. el 409 de traspaso)
const crearError = (data, response) => {
  const error = new Error(data?.error || `Error ${response.status}: ${response.statusText}`);
  error.status = response.status;
  error.data = data;
  return error;
};

const request = async (url, options) => {
  const response = await fetch(url, options);
  const data = await response.json().catch(() => null);
  if (!response.ok) throw crearError(data, response);
  return data;
};

export const getChoferes = (empresa) => {
  const params = new URLSearchParams();
  if (empresa) params.append('empresa', empresa);
  return request(`${API_URL}?${params.toString()}`);
};

export const asignarPosnet = ({ id_chofer, posnet, confirmar_traspaso = false }) =>
  request(`${API_URL}/asignar`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id_chofer,
      posnet,
      confirmar_traspaso,
      usuario: localStorage.getItem('user'),
    }),
  });

export const quitarPosnet = (id_chofer) =>
  request(`${API_URL}/quitar`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id_chofer, usuario: localStorage.getItem('user') }),
  });

export const getHistorial = (id_chofer) =>
  request(`${API_URL}/historial?id_chofer=${encodeURIComponent(id_chofer)}`);

// Terminales Point de la empresa (misma API que usan AddChofer / Editarchofer)
export const getTerminalesMP = async (apiBaseUrl) => {
  const data = await request(`${apiBaseUrl}/api/qr/mp/terminals`);

  if (data?.results) return data.results;
  if (data?.data?.terminals) return data.data.terminals;
  if (Array.isArray(data)) return data;
  return [];
};
